// extracted by mini-css-extract-plugin
export default {"menuItem":"header_menuItem__PpgOT","ant-menu-item-selected":"header_ant-menu-item-selected__TxgZa"};